import axios from 'axios'
import principal from '../utils/principal'

axios.interceptors.request.use(
  (config) => {
    config.headers = {
      Authorization: principal.getPrincipal()
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 403) {
        window.location.href = '/#/admin/login'
      }
    }
    return Promise.reject(error)
  }
)

export const HOST = process.env.VUE_APP_API_URL
const BASE_URL = `${HOST}/api/v1`

export const allInfo = {
  route: () => {
    return axios.get(`${BASE_URL}/read-only/route`)
  }
}

export const user = {
  list: () => {
    return axios.get(`${BASE_URL}/auths`)
  },
  getAuthorization: (userId) => {
    return axios.get(`${BASE_URL}/auths/${userId}/authorization`)
  },
  setAuthorization: (userId, body) => {
    return axios.put(`${BASE_URL}/auths/${userId}/authorization`, body)
  },
  signIn: (email, pw) => {
    return axios.post(`${BASE_URL}/auths/sign-in`, {
      email: email,
      saved: pw
    })
  },
  signUp: (body) => {
    return axios.post(`${BASE_URL}/auths/sign-up`, body)
  }
}

export const image = {
  list: () => {
    return axios.get(`${BASE_URL}/images`)
  },
  get: (imgName) => {
    return axios.get(`${BASE_URL}/images/${imgName}`)
  },
  getUrl: (imgName) => {
    return `${BASE_URL}/images/${imgName}`
  },
  getId: (url) => {
    const match = url?.match(/\/images\/([^/?#]+)/)
    return match ? match[1] : null
  },
  create: (formData) => {
    return axios.post(`${BASE_URL}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  delete: (imgName) => {
    return axios.delete(`${BASE_URL}/images/${imgName}`)
  }
}

export const driver = {
  list: () => {
    return axios.get(`${BASE_URL}/drivers`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/drivers/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/drivers`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/drivers/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/drivers/${id}`)
  }
}

export const manager = {
  list: () => {
    return axios.get(`${BASE_URL}/managers`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/managers/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/managers`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/managers/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/managers/${id}`)
  }
}

export const bus = {
  list: () => {
    return axios.get(`${BASE_URL}/buses`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/buses/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/buses`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/buses/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/buses/${id}`)
  }
}

export const car = {
  list: (text, page, size) => {
    if (text === null || text === '') return axios.get(`${BASE_URL}/cars?page=${page}&size=${size}`)
    else return axios.get(`${BASE_URL}/cars?page=${page}&size=${size}&text=${text}`)
  },
  list_all: () => {
    return axios.get(`${BASE_URL}/cars-all`)
  },
  update: (body) => {
    return axios.post(`${BASE_URL}/cars`, body)
  },
  update_all: (body) => {
    return axios.post(`${BASE_URL}/cars-all`, body)
  },
  search_number: (number) => {
    return axios.get(`${BASE_URL}/cars-number?number=${number}`)
  },
  delete: (number) => {
    return axios.delete(`${BASE_URL}/cars/${number}`)
  }
}

export const station = {
  list: () => {
    return axios.get(`${BASE_URL}/stations`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/stations/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/stations`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/stations/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/stations/${id}`)
  }
}

export const busDispatchStation = {
  list: () => {
    return axios.get(`${BASE_URL}/bus-dispatches-stations`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/bus-dispatches-stations/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/bus-dispatches-stations`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/bus-dispatches-stations/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/bus-dispatches-stations/${id}`)
  }
}

export const busDispatch = {
  list: () => {
    return axios.get(`${BASE_URL}/bus-dispatches`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/bus-dispatches/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/bus-dispatches`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/bus-dispatches/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/bus-dispatches/${id}`)
  }
}

export const route = {
  list: () => {
    return axios.get(`${BASE_URL}/routes`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/routes/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/routes`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/routes/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/routes/${id}`)
  }
}

export const routeGroup = {
  list: () => {
    return axios.get(`${BASE_URL}/route-groups`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/route-groups/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/route-groups`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/route-groups/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/routes-groups/${id}`)
  }
}

export const parking = {
  list: () => {
    return axios.get(`${BASE_URL}/parkings`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/parkings/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/parkings`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/parkings/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/parkings/${id}`)
  },
  getImgs: (id) => {
    return axios.get(`${BASE_URL}/parkings/${id}/images`)
  },
  setImg: (id, body) => {
    return axios.put(`${BASE_URL}/parkings/${id}/images`, body)
  }
}

export const weeklyPaper = {
  list: (page, size) => {
    return axios.get(`${BASE_URL}/weekly-titles?page=${page}&size=${size}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/weeklies`, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  setTitle: (date, body) => {
    return axios.put(`${BASE_URL}/weeklies/${date}/title`, body)
  },
  setPrintDate: (date, body) => {
    return axios.put(`${BASE_URL}/weeklies/${date}/print-date`, body)
  },
  setPriority: (date, body) => {
    return axios.put(`${BASE_URL}/weeklies/${date}/priority`, body)
  },
  remove: (date) => {
    return axios.delete(`${BASE_URL}/weeklies/${date}`)
  }
}

export const advertise = {
  getLocation: () => {
    return axios.get(`${BASE_URL}/ad?type=LocationWeb`)
  }
}

export const announcement = {
  list: (page, size) => {
    return axios.get(`${BASE_URL}/announcements?visible=all&page=${page}&size=${size}`)
  },
  get: (id) => {
    return axios.get(`${BASE_URL}/announcements/${id}`)
  },
  create: (body) => {
    return axios.post(`${BASE_URL}/announcements`, body)
  },
  set: (id, body) => {
    return axios.put(`${BASE_URL}/announcements/${id}`, body)
  },
  delete: (id) => {
    return axios.delete(`${BASE_URL}/announcements/${id}`)
  }
}
